import { ArrowRight } from "lucide-react";

const PALLET_TYPES = [
  {
    id: "universal",
    name: "Pallet Universal",
    dim: "1200 × 1000 mm",
    body: "El estándar de la industria. Base de 4 entradas, ideal para almacenaje, transporte intermodal y montacargas de cualquier marca.",
    uses: ["Bodegaje general", "Distribución nacional", "Carga sobre 1.000 kg"],
    image:
      "https://images.unsplash.com/photo-1573209680076-bd7ec7007616?auto=format&fit=crop&w=900&q=80",
  },
  {
    id: "yugo",
    name: "Pallet Yugo",
    dim: "1100 × 1100 mm",
    body: "Diseño reforzado con largueros tipo yugo para mayor resistencia estructural. Pensado para cargas pesadas y rotación intensiva.",
    uses: ["Construcción", "Materiales pesados", "Patios de operación"],
    image:
      "https://images.unsplash.com/photo-1689942010216-dc412bb1e7a9?auto=format&fit=crop&w=900&q=80",
  },
  {
    id: "tunel",
    name: "Pallet Tipo Túnel",
    dim: "1200 × 1000 mm",
    body: "Con dos aberturas tipo túnel en sus costados largos para entrada exclusiva de transpaletas. Optimiza picking en líneas logísticas.",
    uses: ["Centros de distribución", "Líneas con transpaleta", "Rotación rápida"],
    image:
      "https://images.unsplash.com/photo-1532635026-d12867005472?auto=format&fit=crop&w=900&q=80",
  },
  {
    id: "europallet",
    name: "Euro Pallet",
    dim: "1200 × 800 mm",
    body: "Medida estándar europea (EPAL). Compatible con contenedores marítimos y exigencias de exportación. Marcado y trazable.",
    uses: ["Exportación", "Retail / supermercado", "Cadenas internacionales"],
    image:
      "https://images.unsplash.com/photo-1532635026-d12867005472?auto=format&fit=crop&w=900&q=80&sat=-30",
  },
];

export default function PalletTypes({ onSelectType }) {
  const handleSelect = (type) => {
    if (onSelectType) onSelectType(type);
    const el = document.getElementById("cotizar");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section
      id="tipos"
      data-testid="pallet-types-section"
      className="border-b-2 border-vp-yellow bg-vp-navy-deep"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-12 lg:py-16 border-b-2 border-white/15">
        <div className="flex items-center gap-3 mb-6">
          <span className="w-10 h-[2px] bg-vp-yellow" />
          <span className="label-industrial">03 · Catálogo operativo</span>
        </div>
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <h2 className="heading-industrial text-4xl sm:text-5xl lg:text-6xl max-w-3xl text-white">
            Cuatro modelos.
            <br />
            <span className="text-vp-yellow">Una sola exigencia:</span> que
            soporten tu operación.
          </h2>
          <p className="text-white/75 max-w-md text-lg">
            Cada modelo cumple norma de carga industrial. Selecciona el que se
            ajusta a tu flujo logístico y cotiza al instante.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4">
        {PALLET_TYPES.map((p, i) => (
          <article
            key={p.id}
            data-testid={`pallet-card-${p.id}`}
            className={`group relative bg-vp-navy flex flex-col ${
              i < PALLET_TYPES.length - 1
                ? "xl:border-r-2 border-white/15"
                : ""
            } ${i % 2 === 0 ? "md:border-r-2 md:xl:border-r-2 border-white/15" : ""} border-b-2 border-white/15 last:border-b-0 xl:border-b-0 hover:bg-vp-navy-soft transition-colors`}
          >
            <div className="relative aspect-[4/3] overflow-hidden bg-vp-navy-deep border-b-2 border-white/15">
              <img
                src={p.image}
                alt={`${p.name} — Vigopal`}
                className="absolute inset-0 w-full h-full object-cover opacity-90 group-hover:opacity-100 group-hover:scale-105 transition-all duration-500"
              />
              <div className="absolute top-3 left-3 bg-vp-yellow text-[#001E62] px-3 py-1 text-[10px] font-bold uppercase tracking-widest">
                0{i + 1}
              </div>
              <div className="absolute bottom-3 right-3 bg-vp-navy border-2 border-vp-yellow text-white px-3 py-1 text-[11px] font-bold uppercase tracking-widest">
                {p.dim}
              </div>
            </div>

            <div className="p-6 flex-1 flex flex-col">
              <h3 className="heading-industrial text-2xl mb-2 text-white group-hover:text-vp-yellow transition-colors">
                {p.name}
              </h3>
              <p className="text-sm text-white/75 leading-relaxed mb-4">
                {p.body}
              </p>

              <ul className="space-y-1.5 mb-6 mt-auto">
                {p.uses.map((u) => (
                  <li
                    key={u}
                    className="text-xs text-white/70 flex items-center gap-2"
                  >
                    <span className="w-3 h-[2px] bg-vp-red" />
                    {u}
                  </li>
                ))}
              </ul>

              <button
                type="button"
                onClick={() => handleSelect(p)}
                data-testid={`pallet-cta-${p.id}`}
                className="inline-flex items-center justify-between gap-3 bg-vp-red hover:bg-vp-yellow hover:text-[#001E62] text-white font-bold uppercase tracking-widest text-xs px-4 py-3 transition-colors"
              >
                Cotizar este modelo
                <ArrowRight size={14} />
              </button>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
